import { useEffect, useState } from 'react';
import { BALL } from '../../theme.js';

const T = BALL;

export default function WordBank({ exercise, lang, onResult, locked, registerSubmit }) {
  const [selected, setSelected] = useState([]); // indices into exercise.bank
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    setSelected([]);
    setSubmitted(false);
  }, [exercise]);

  function pick(idx) {
    if (locked || submitted) return;
    setSelected((prev) => [...prev, idx]);
  }

  function unpick(idx) {
    if (locked || submitted) return;
    setSelected((prev) => prev.filter((i) => i !== idx));
  }

  function submit() {
    if (locked || submitted || selected.length === 0) return;
    const given = selected.map((i) => exercise.bank[i]);
    const correct =
      given.length === exercise.correct.length &&
      given.every((w, i) => w.toLowerCase() === exercise.correct[i].toLowerCase());
    setSubmitted(true);
    onResult({
      correct,
      given: given.join(' '),
      expected: exercise.correct.join(' '),
    });
  }

  registerSubmit?.(submit);

  const tokenStyle = (extra = {}) => ({
    appearance: 'none', cursor: 'pointer',
    background: T.bgAlt,
    border: `2px solid ${T.hairline}`,
    borderRadius: 10,
    boxShadow: `0 3px 0 ${T.hairline}`,
    padding: '10px 14px', fontSize: 17, fontWeight: 800,
    color: T.primary, fontFamily: 'inherit',
    ...extra,
  });

  return (
    <div style={{ padding: '4px 22px 0', display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div>
        <div style={{
          fontSize: 11, fontWeight: 800, color: T.blue, letterSpacing: '0.12em',
        }}>{lang === 'en' ? 'BUILD THE SENTENCE' : 'BYGG MENINGEN'}</div>
        <h2 style={{
          fontSize: 24, fontWeight: 900, color: T.ink, margin: '6px 0 0', lineHeight: 1.15,
        }}>{exercise.prompt}</h2>
      </div>

      {/* Answer area */}
      <div style={{
        minHeight: 60,
        borderBottom: `2px dashed ${T.hairline}`,
        padding: '12px 4px',
        display: 'flex', flexWrap: 'wrap', gap: 8, alignContent: 'flex-start',
      }}>
        {selected.length === 0 && (
          <span style={{ color: T.inkSoft, fontSize: 24, fontWeight: 800 }}>…</span>
        )}
        {selected.map((idx) => (
          <button
            key={`s-${idx}`}
            type="button"
            onClick={() => unpick(idx)}
            disabled={locked || submitted}
            style={tokenStyle()}
          >
            {exercise.bank[idx]}
          </button>
        ))}
      </div>

      {/* Word bank */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {exercise.bank.map((w, idx) =>
          selected.includes(idx) ? (
            <div key={`b-${idx}`} style={{
              ...tokenStyle({ background: T.hairline, borderColor: 'transparent', color: 'transparent', boxShadow: 'none' }),
              visibility: 'hidden',
            }}>{w}</div>
          ) : (
            <button
              key={`b-${idx}`}
              type="button"
              onClick={() => pick(idx)}
              disabled={locked || submitted}
              style={tokenStyle()}
            >
              {w}
            </button>
          )
        )}
      </div>
    </div>
  );
}
